import { KeyValueMatchFilter } from "../../param/generalSearchFilter";
import { ListDefinition } from "../../param/listDefinitionType";
import { Result } from "./generalSearchResult";
import { processNestedFunctions } from "./patternFunctions";

export const createKeyValueTable = (
  result: Result,
  listDefinitionsTable: Record<string, ListDefinition>,
  query: KeyValueMatchFilter
) => {
  const table: Record<string, string[]> = {};
  for (const content of result) {
    const keys = processNestedFunctions(
      query.key,
      listDefinitionsTable,
      content.trace
    );

    const values = processNestedFunctions(
      query.value,
      listDefinitionsTable,
      content.trace
    );
    keys.forEach((key) => {
      values.forEach((value) => {
        table[key] = table[key] ?? [];
        table[key].push(value);
      });
    });
  }
  return table;
};
